module.exports = __webpack_public_path__ + "img/file-return.c2d0684a.webp";